export default "__VITE_ASSET__DkakYb1D__"